<template>
  <div :class="[[isEdit ? 'border-edit' : 'border-white'], classSize]">
    <div class="avatar" :class="[imageUrl ? 'background-white' : '']">
      <div v-if="!imageUrl && !userName" class="briefcase">
        <Icon name="Briefcase" color="white" />
      </div>
      <div v-else-if="!imageUrl">
        <label class="letter">{{ letter }}</label>
      </div>
      <img v-else class="imagem" :src="imageUrl" alt="avatar" />
      <div class="edit" @click="handleClick">
        <span>{{ labelEdit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../Icon/Icon.vue';

export default {
  components: {
    Icon,
  },
  props: {
    imageUrl: String,
    userName: String,
    isEdit: Boolean,
    labelEdit: {
      type: String,
      default: 'Editar',
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
    handleClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    letter() {
      if (!this.userName) {
        return '';
      }
      return this.userName.substr(0, 1);
    },
    classSize() {
      return `size-${this.size}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.size-sm {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  box-sizing: border-box;
  border: var(--track-color-bluegray-30) 1.6px solid;
  border-radius: 50%;
  font-size: 8px;
}

.size-md {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;
  box-sizing: border-box;
  border: var(--track-color-bluegray-30) 1.6px solid;
  border-radius: 50%;
  font-size: var(--track-font-size-xs);
}

.size-lg {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 64px;
  box-sizing: border-box;
  border: var(--track-color-bluegray-30) 2px solid;
  border-radius: 50%;
  font-size: var(--track-font-size-xs);
}

.border-edit:hover {
  border-color: var(--track-color-bluegray-60);
}

.border-white:hover {
  border-color: var(--track-color-white);
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--track-color-bluegray-30);
  border-radius: 50%;
  overflow: hidden;
}

.background-white {
  background: var(--track-color-white);
}

.imagem {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.size-sm svg {
  height: 18px;
  width: 18px;
}

.briefcase {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

span,
label {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  color: var(--track-color-white);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.size-sm .letter {
  font-size: var(--track-font-size-sm);
  font-weight: var(--track-font-weight-regular);
}

.size-lg .letter {
  font-size: var(--track-font-size-xl);
}

.letter {
  text-transform: uppercase;
  font-size: var(--track-font-size-lg);
}

.edit {
  border-radius: 50%;
  display: none;
}

.size-sm .edit,
.size-sm .avatar {
  width: calc(32px - 6px);
  height: calc(32px - 6px);
}

.size-md .edit,
.size-md .avatar {
  width: calc(48px - 6px);
  height: calc(48px - 6px);
}

.size-lg .edit,
.size-lg .avatar {
  width: calc(64px - 8px);
  height: calc(64px - 8px);
}

.border-edit:hover .avatar .edit {
  display: block;
  position: absolute;
  cursor: pointer;
  background-color: rgba(16, 42, 67, 0.6);
}
</style>
